import React from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import {
  Grid,
  Form,
  Segment,
  Checkbox,
} from 'semantic-ui-react';
import { DateInput } from 'semantic-ui-calendar-react';

import iframe from '../../../dashboard-routes/Iframe/iframeData';
import DoctorDetailsStore from './DoctorDetailsStore';
import TextArea from './TextArea';
import { Upload, File, NoFile } from './Upload';
import './DoctorDetails.scss';

@observer
class RecruitmentLoginInformationTab extends React.Component {
  renderClientType = type => {
    switch (type) {
      case 0:
        return 'ICS Ultimate';
      case 1:
        return 'ICS Direct-Essential';
      case 2:
        return 'ICS Direct-Extra';
      default:
        return 'None';
    }
  };

  @action uploadContract = data => {
    const contract = data.fileList[0];
    if (contract) {
      DoctorDetailsStore.dataDoctor.ContractAttachmentDisplayName =
        contract.name;
      DoctorDetailsStore.dataDoctor.ContractAttachmentPhysicalFileName =
        contract.title;
    }
  };

  @action removeContract = () => {
    DoctorDetailsStore.dataDoctor.ContractAttachmentDisplayName = null;
    DoctorDetailsStore.dataDoctor.ContractAttachmentPhysicalFileName = null;
  };

  openClinicCalendar = () => {
    const { dataDoctor } = DoctorDetailsStore;
    iframe.forceOpenTab(
      'ManageCalendar',
      `?doctorId=${dataDoctor.Id}&view=ManageCalendar`,
      {
        doctorId: dataDoctor.Id,
        view: 'ManageCalendar',
      },
    );
  };

  render() {
    const {
      isEditing,
      dataDoctor,
      setFieldValue,
      toggleCheckbox,
    } = DoctorDetailsStore;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Segment className="Segment-View">
              <Form>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label className="Form-Group-label">
                      Recruitment And Login Information
                    </label>
                  </Form.Field>
                </Form.Group>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label className="Form-Field-label">
                      Onboarded Date (Contract Date)
                    </label>
                    {!isEditing ? (
                      <div>
                        <span className="Label-item">
                          {dataDoctor.ContractWithMagDate || 'None'}
                        </span>
                      </div>
                    ) : (
                      <DateInput
                        name="ContractWithMagDate"
                        animation=""
                        duration={0}
                        disabled
                        clearable
                        placeholder="dd/mm/yyyy"
                        value={dataDoctor.ContractWithMagDate || ''}
                        onChange={setFieldValue}
                      />
                    )}
                  </Form.Field>
                  <Form.Field>
                    <label className="Form-Field-label">
                      Contract End Date
                    </label>
                    {!isEditing ? (
                      <div>
                        <span className="Label-item">
                          {dataDoctor.ContractWithMagEndDate || 'None'}
                        </span>
                      </div>
                    ) : (
                      <DateInput
                        name="ContractWithMagEndDate"
                        animation=""
                        duration={0}
                        disabled
                        clearable
                        placeholder="dd/mm/yyyy"
                        value={dataDoctor.ContractWithMagEndDate || ''}
                        onChange={setFieldValue}
                      />
                    )}
                  </Form.Field>
                </Form.Group>
                <Form.Field width="8">
                  <label className="Form-Field-label">Attach Contract</label>
                  {!isEditing ? (
                    dataDoctor.ContractAttachmentPhysicalFileName === null ? (
                      <NoFile />
                    ) : (
                      <File
                        name={dataDoctor.ContractAttachmentDisplayName}
                        downloadLink={`/UserFile/DoctorContract/${dataDoctor.ContractAttachmentPhysicalFileName}`}
                      />
                    )
                  ) : dataDoctor.ContractAttachmentPhysicalFileName === null ? (
                    <Upload
                      onComplete={this.uploadContract}
                      placeholder="Upload your contract"
                    />
                  ) : (
                    <File
                      name={dataDoctor.ContractAttachmentDisplayName}
                      downloadLink={`/UserFile/DoctorContract/${dataDoctor.ContractAttachmentPhysicalFileName}`}
                      onRemove={this.removeContract}
                    />
                  )}
                </Form.Field>
              </Form>
            </Segment>
            <Segment>
              <Form>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label className="Form-Field-label">
                      Available for Online Bookings
                    </label>
                    <Checkbox
                      label={`${
                        dataDoctor.AvailableForCMView
                          ? `Available`
                          : `Not Available`
                      }`}
                      className="Form-field-radio"
                      name="AvailableForCMView"
                      checked={dataDoctor.AvailableForCMView}
                      disabled
                      onChange={toggleCheckbox}
                    />
                    
                  </Form.Field>
                </Form.Group>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label className="Form-Field-label">
                      Enable login
                    </label>
                    <Checkbox
                      label={`${dataDoctor.EnableLogin ? `Enable` : `Disable`}`}
                      className="Form-field-radio"
                      name="EnableLogin"
                      checked={dataDoctor.EnableLogin}
                      disabled
                      onChange={toggleCheckbox}
                    />
                  </Form.Field>
                  <Form.Field>
                    <label className="Form-Field-label">Username</label>
                    <div>
                      <span className="Label-item">
                        {dataDoctor.Username || 'None'}
                      </span>
                    </div>
                  </Form.Field>
                </Form.Group>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label className="Form-Field-label">
                      Not Currently Interested (NCI)
                    </label>
                    <Checkbox
                      label="Not Currently Interested (NCI)"
                      className="Form-field-radio"
                      name="IsNotCurrentlyInterested"
                      disabled
                      checked={dataDoctor.IsNotCurrentlyInterested}
                      onChange={toggleCheckbox}
                    />
                  </Form.Field>
                </Form.Group>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label className="Form-Field-label">NCI Start Date:</label>
                    {!isEditing ? (
                      <div>
                        <span className="Label-item">
                          {dataDoctor.NotCurrentlyInterestedDate || 'None'}
                        </span>
                      </div>
                    ) : (
                      <DateInput
                        name="NotCurrentlyInterestedDate"
                        animation=""
                        duration={0}
                        disabled
                        clearable
                        placeholder="dd/mm/yyyy"
                        value={dataDoctor.NotCurrentlyInterestedDate || ''}
                        onChange={setFieldValue}
                      />
                    )}
                  </Form.Field>
                  <Form.Field>
                    <label className="Form-Field-label">NCI End Date:</label>
                    {!isEditing ? (
                      <div>
                        <span className="Label-item">
                          {dataDoctor.NotCurrentlyInterestedEndDate || 'None'}
                        </span>
                      </div>
                    ) : (
                      <DateInput
                        name="NotCurrentlyInterestedEndDate"
                        animation=""
                        duration={0}
                        clearable
                        disabled
                        placeholder="dd/mm/yyyy"
                        value={dataDoctor.NotCurrentlyInterestedEndDate || ''}
                        onChange={setFieldValue}
                      />
                    )}
                  </Form.Field>
                </Form.Group>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label className="Form-Field-label">NCI Comment</label>
                    {!isEditing ? (
                      <div>
                        <span className="Label-item">
                          {dataDoctor.NotCurrentlyInterestedComment || 'None'}
                        </span>
                      </div>
                    ) : (
                      <TextArea
                        name="NotCurrentlyInterestedComment"
                        disabled
                      />
                    )}
                  </Form.Field>
                </Form.Group>
              </Form>
            </Segment>
          </Grid.Column>
          {this.props.children}
        </Grid.Row>
      </Grid>
    );
  }
}
export default RecruitmentLoginInformationTab;
